import { render, staticRenderFns } from "./MonitoringAgentFee.vue?vue&type=template&id=5868348e"
import script from "./MonitoringAgentFee.vue?vue&type=script&lang=js"
export * from "./MonitoringAgentFee.vue?vue&type=script&lang=js"
import style0 from "./MonitoringAgentFee.vue?vue&type=style&index=0&id=5868348e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports